require('fslightbox');

export function SetupLightbox() {
    const coreImagesThatLinkToMedia = document.querySelectorAll("figure > a > img, [class*=‘wp-image’], a > .wp-post-image, .woocommerce-product-gallery__image > a > img")
    for (const image of coreImagesThatLinkToMedia) {
        const parentLink = image.parentElement;
        if (parentLink.tagName !== "A") {
            // we expect the parent to be an A tag
            continue;
        }
        if (parentLink.getAttribute('href').match(/\.jpg|\.png|\.svg|\.gif|\.webp/)) {
            parentLink.setAttribute('data-fslightbox', true)
            parentLink.setAttribute('data-type', 'image');
        }
    }
    refreshFsLightbox();
}